export default __webpack_public_path__ + "static/media/Template5.d9e56856.jpg";